module.exports = __webpack_public_path__ + "img/Market share Icon - white.234c7928.svg";